//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useEffect, useContext } from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { makeStyles } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { useHistory } from 'react-router-dom';

//logo and image

import successSrc from '../../images/advertise/success.jpg';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { unsubscribeRealtimeUpdates } from '../system/firebase';
import { LayoutContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
// import AfitdTypography from '../../common/elemental/AfitdTypography';
// import AfitdTextField from '../../common/elemental/AfitdTextField';
import AfitdButton from '../../common/elemental/AfitdButton';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------
import { HOMEPAGE_CONTACT, BASE_URL } from '../../common/constants';
import { PATH_ADVERTISE, PATH_HOME } from '../../system/constants';

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
// import AfitdTypography from '../../common/elemental/AfitdTypography';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
// import SubComponent1Example from './SubComponent1Example';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
import _get from 'lodash/get';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = makeStyles(theme => ({
    root: {
        backgroundImage: `url(${successSrc})`,
        backgroundRepeat: 'no-repeat',
        textAlign: 'center',
        backgroundSize: 'cover',
        paddingTop: 20,
        width: '100%',
        height: '680px',
        [theme.breakpoints.down('sm')]: { height: '100%' },
    },
    exampleWithNoPropsOnlyStyles: { color: 'red', marginTop: 30, marginBottom: 40 },
    nonReactElementExample: { color: 'blue', marginTop: 50, cursor: 'pointer' },
    heading: {
        fontWeight: 'bold',
        fontSize: '54px',
        lineHeight: '68px',
        color: 'white',
        marginTop: '20px',
        marginBottom: '20px',
    },
    details: {
        fontWeight: 'normal',
        fontSize: '20px',
        lineHeight: '34px',
        color: 'white',
    },
    bold: {
        textDecoration: 'underline',
        fontWeight: 'bold',
    },
    iconCheck: {
        fontSize: '60px',
        color: 'white',
        marginTop: '50px',
        [theme.breakpoints.down('md')]: { marginTop: 40 },
    },
    haveQuestion: {
        marginTop: '100px',
        [theme.breakpoints.down('md')]: { marginTop: '20px' },
    },
    bannerBottomHeading: {
        margin: 'auto',
        fontWeight: 'bold',
        fontSize: '42px',
        lineHeight: '59px',
        marginTop: '80px',
        marginBottom: '74px',
        textAlign: 'center',
        [theme.breakpoints.down('md')]: { marginBottom: '40px' },
    },
    bottomText: {
        fontSize: '20px',
        textAlign: 'center',
    },
    contactLink: {
        fontWeight: 'bold',
        textDecoration: 'underline',
        color: '#1D8A8B',
        cursor: 'pointer',
    },
}));

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { classes, history, handleClickBackToHome } = params;

    const defns = {
        helloText: { variant: 'h4' },
        textFieldExample: { value: 'Hello TextField' },
        nonReactElementExample: {
            onClick: evt => {
                alert('Clicked!');
            },
        },

        backButton: {
            onClick: handleClickBackToHome,
            style: {
                backgroundColor: '#1D8A8B',
                color: 'white',
                marginTop: '30px',
            },
        },
        contactLink: {
            onClick: () => history.push(`${BASE_URL}${PATH_HOME}/${HOMEPAGE_CONTACT}`),
        },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const SuccessPage = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles();
    const history = useHistory();
    // const appContext = useContext(AppContext);
    // const { currentUser, userId, profileData, currentEmployer, employerId, lovs } = appContext;

    const layoutContext = useContext(LayoutContext);
    const { scrollToPageTop, customerData, handleClickBackToHome } = layoutContext;
    const adCusId = _get(customerData, 'adCusId', null);

    // const { setSnackbarMessage, setSnackbarErrorMessage } = layoutContext;

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    // const { propExample } = props;

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    // const [isDirty, setIsDirty] = useState(false);

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    // on mount, scroll to the top of the page
    useEffect(() => {
        scrollToPageTop();
    }, [scrollToPageTop]);

    useEffect(() => {
        if (!adCusId) history.push(`${BASE_URL}${PATH_ADVERTISE}/start`);
        // don't need to run multiple Times
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props, history, handleClickBackToHome });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <>
            <div {...defns.root}>
                <CheckCircleIcon {...defns.iconCheck} />
                <p {...defns.heading}>SUCCESS!</p>
                <p {...defns.details}>
                    Thank you very much for your purchase. <br />
                    For any questions or concerns with your ad placement,
                    <br />
                    Please reach out to
                    <span {...defns.bold}> support@afootinthedoor.com</span>
                </p>
                <div>
                    <AfitdButton {...defns.backButton}>Back To Home</AfitdButton>
                </div>
            </div>
            <div {...defns.haveQuestion}>
                <div {...defns.bannerBottomHeading}>Have other questions?</div>
                <div {...defns.bottomText}>
                    <span {...defns.contactLink}>Contact Us</span>
                    <span> here so we can help</span>
                </div>
            </div>
        </>
    );
};

export default SuccessPage;
